import "./view.scss";

/**
 * Skip continuous parallax rAF on mobile (TBT under 4x CPU throttle).
 */
(function initColumnParallax() {
  if (
    window.matchMedia("(max-width: 767px)").matches ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  // Moderate viewport-based travel — visible without feeling too fast.
  const PARALLAX_FACTORS = {
    1: 0.1,
    2: 0.16,
  };
  const PARALLAX_OVERFLOW_RATIO = 0.12;

  const parallaxItems = [];
  let rafId = null;
  let ticking = false;

  document
    .querySelectorAll(".column-parallax-images .column-parallax__layer")
    .forEach((layer) => {
      if (layer.dataset.parallaxBound) return;
      layer.dataset.parallaxBound = "1";

      const el =
        layer.querySelector(".column-parallax__parallax-inner") || layer;
      const block = layer.closest(".wp-block-blueprint-column");
      const layerIndex = parseInt(layer.dataset.layer, 10);
      const factor = PARALLAX_FACTORS[layerIndex] ?? 0.1;

      parallaxItems.push({
        el,
        block,
        layer,
        factor,
        visible: false,
        lastTranslate: null,
      });
    });

  if (!parallaxItems.length) {
    return;
  }

  function updateParallax() {
    ticking = false;
    const hasVisible = parallaxItems.some((item) => item.visible);
    if (!hasVisible) {
      rafId = null;
      return;
    }

    const viewportHeight = window.innerHeight;
    const writes = [];

    parallaxItems.forEach((item) => {
      if (!item.visible) return;

      const rect = item.layer.getBoundingClientRect();
      // Only animate while the layer itself intersects the viewport.
      if (rect.bottom <= 0 || rect.top >= viewportHeight) return;

      const travel = viewportHeight;
      const maxTranslate = viewportHeight * PARALLAX_OVERFLOW_RATIO;
      // 0 when the layer first enters (top at viewport bottom), 1 when leaving.
      const progress = Math.max(
        0,
        Math.min(
          1,
          (viewportHeight - rect.top) / (viewportHeight + rect.height)
        )
      );
      let translate = progress * travel * item.factor;
      translate = Math.max(-maxTranslate, Math.min(maxTranslate, translate));
      translate = Math.round(translate);

      if (item.lastTranslate === translate) return;
      item.lastTranslate = translate;
      writes.push({ el: item.el, translate });
    });

    writes.forEach(({ el, translate }) => {
      el.style.transform = `translate3d(0, ${translate}px, 0)`;
    });

    rafId = requestAnimationFrame(updateParallax);
  }

  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    rafId = requestAnimationFrame(updateParallax);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      let anyVisible = false;
      entries.forEach((entry) => {
        parallaxItems.forEach((item) => {
          if (item.layer === entry.target) {
            item.visible = entry.isIntersecting;
          }
          if (item.visible) anyVisible = true;
        });
      });

      if (anyVisible) {
        scheduleUpdate();
      } else if (rafId != null) {
        cancelAnimationFrame(rafId);
        rafId = null;
        ticking = false;
      }
    },
    { rootMargin: "0px", threshold: 0 }
  );

  const observed = new Set();
  parallaxItems.forEach((item) => {
    if (!observed.has(item.layer)) {
      observer.observe(item.layer);
      observed.add(item.layer);
    }
  });

  const bindLenis = () => {
    if (!window.lenis || typeof window.lenis.on !== "function") return false;
    window.lenis.on("scroll", scheduleUpdate);
    return true;
  };

  if (!bindLenis()) {
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (bindLenis() || tries >= 40) {
        window.clearInterval(timer);
      }
    }, 50);
  }
})();
